import React, { useMemo } from 'react'
import AiSuggestedSection from './index'
import { readAnchoredActionSet } from '../../../utils/aiAnalysis/draftPayload'

const SuggestedSectionHost: React.FC = () => {
  const payload = useMemo(readAnchoredActionSet, [])

  if (!payload) {
    return null
  }

  return <AiSuggestedSection {...payload} onDecisionStateStale={() => window.location.reload()} />
}

export default SuggestedSectionHost
